<template>
  <HeroView
      title="Megastore"
      text="Multipurpose theme for any catalog size — with conversion tools, modern design, and sales-focused merchandising features."
      purchase-link="https://themes.shopify.com/themes/megastore/styles/megastore"
      preview-link="https://themes.shopify.com/themes/megastore/styles/megastore/preview"
      price="$380"
      img-main="/assets/imgs/themes/megastore/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/megastore/hero/hero.webp 1x, /assets/imgs/themes/megastore/hero/hero@2x.webp 2x"
  />

  <DemosView
      title="5 Sales-Optimized <br>Pre-Designed Presets"
      text="Explore 5 powerful presets—built to boost sales and deliver results with proven layouts and features."
      theme-id="megastore"
  />
  <BannerView
      title="Create a Store That’s a Sales Engine in Every Pixel"
      text="Every section and detail is designed to sell more — from advanced filtering and promo blocks to a minimalist modular layout with structured grids and modern typography."
      purchase-link="https://themes.shopify.com/themes/megastore/styles/megastore"
      preview-link="https://themes.shopify.com/themes/megastore/styles/megastore/preview"
      price="$380"
      img-main="/assets/imgs/themes/megastore/banner@2x.webp"
      img-set="/assets/imgs/themes/megastore/banner.webp 1x, /assets/imgs/themes/megastore/banner@2x.webp 2x"
  />
  <FeaturesView/>
  <BuiltView/>
  <DocView
      doc-link="/help-center/documentation/megastore/"
      img-main="/assets/imgs/themes/megastore/doc/doc@2x.webp"
      img-set="/assets/imgs/themes/megastore/doc/doc.webp 1x, /assets/imgs/themes/megastore/doc/doc@2x.webp 2x"
  />
  <FinalView
      title="Launch with a Theme That Converts"
      text="Everything in this theme is optimized to help you convert more, boost&nbsp;revenue, and grow faster."
      purchase-link="https://themes.shopify.com/themes/megastore/styles/megastore"
      preview-link="https://themes.shopify.com/themes/megastore/styles/megastore/preview"
      price="$380"
      img-main="/assets/imgs/themes/megastore/final@2x.webp"
      img-set="/assets/imgs/themes/megastore/final.webp 1x, /assets/imgs/themes/megastore/final@2x.webp 2x"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'MegastoreView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>
